import CopyingText from './CopyingText';

export default CopyingText;
